<template>
    <div class="us-write">
        <div class="container us-write__container">
            <div class="row">
                <div class="col-md-12">
                    <h2 class="us-write__title container__title">О нас пишут</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <swiper ref="usWrite" class="us-write-slider write-card"  :options="usWriteSlideOptions">
                        <swiper-slide class="write-card__item d-flex" v-for="(slide, idx) in slides" :key="idx">
                            <div class="write-card__wrap d-flex">
                                <div class="write-card__ico">
                                    <img
                                        :src="slide.image"
                                        alt="card-log"
                                        aria-label="cardimage"
                                    />
                                </div>
                                <p class="write-card__body" v-text="slide.text"></p>
                                <div class="write-card__divider"></div>
                                <span class="write-card__date" v-text="slide.date"></span>
                            </div>
                            <div class="write-card__show" v-if="slide.link">
                                <a  v :href="slide.link" class="write-card__link">Читать</a>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="write-card__navigation">
                        <div id="write-card-prev"
                            class="swiper-button-prev"
                            slot="button-prev"
                        ></div>
                        <div
                            id="write-card-next"
                            class="swiper-button-next "
                            slot="button-next"
                        ></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {Swiper, SwiperSlide, Navigation} from 'vue-awesome-swiper'

export default {
    name: 'UsWrite',
    data() {
        return {
            usWriteSlideOptions: {
                slidesPerView: 3,
                spaceBetween: 30,
                centeredSlides: false,
                loop: true,
                speed: 1400,
                navigation: {
                    nextEl: '#write-card-next',
                    prevEl: '#write-card-prev'
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 10
                    },
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    }
                }
            },
            slides:[
                {
                    id: 1,
                    image: '/assets/images/estern.png',
                    link: 'https://eapcivilsociety.eu/hackathons/new-hackathon-2020',
                    text: 'The platform is aimed to save volunteers’ time and help them focus only on saving the animals, leaving all administrative work behind.',
                    date: '20.10.2020'
                },
                {
                    id: 2,
                    image: '/assets/images/c-1.png',
                    // link: 'https://eapcivilsociety.eu/hackathons/new-hackathon-2020',
                    text: 'Gooood Boy Party (0+). Уже 5 октября Gooood Boy Party организуют самый добрый и прозрачный фестиваль помощи хвостикам.',
                    date: '5 октября 2019'
                },
                {
                    id: 3,
                    image: '/assets/images/smi-three.png',
                    link: 'https://24.kz/ru/news/in-the-world/item/364409-internet-proekt-dlya-pomoshchi-bezdomnym-zhivotnym-zapustyat-v-belarusi',
                    text: 'Интернет-проект для помощи бездомным животным запустят в Беларуси',
                    date: '29.12.2019'
                },
            ]
        }
    },
    components: {Swiper, SwiperSlide, Navigation},
    computed: {
        swiper() {
            return this.$refs.usWrite.$swiper
        }
    },
    mounted(){
    },
}
</script>

<style lang="scss">
.us-write {
    padding: 45px 0;
    padding-top: 125px;
    background: #eaf1fc url(/assets/images/media.png) no-repeat left 80px;
    background-size: 685px;
    background-position-y: 70px;

    &__title {
        margin-bottom: 60px;
    }
}

.write-card {
    width: 100%;
    position: relative;
    font-family: 'Comfortaa', sans-serif;

    &__wrap {
        padding: 15px;
        color: #555555;
        min-height: 233px;
        display: flex;
        flex-flow: column nowrap;
    }

    &__item {
        flex-flow: column nowrap;
        background: #ffffff;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        overflow: hidden;

        &:hover {
            .write-card__show {
                opacity: 1;
            }
        }
    }

    &__ico {
        max-width: 40px;
        margin-bottom: 15px;
        height: 60px;
        img {
            width: 100%;
            height: auto;
            object-fit: cover;
        }
    }

    &__body {
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        height: 72px;
        font-weight: 700;
        font-size: 12px;
        line-height: 18px;
        flex-grow: 1;
    }

    &__divider {
        background: #ee7372;
        border-radius: 5px;
        width: 85px;
        height: 2px;
        margin: 16px 0;
    }

    &__date {
        font-size: 10px;
        line-height: 18px;
    }

    &__show {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        opacity: 0;
        justify-content: center;
        background: linear-gradient(
                90deg,
                rgba(46, 118, 228, 0.8) 0%,
                rgba(107, 78, 188, 0.8) 100%
        );
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        transition: opacity 0.3s ease;
    }

    &__link {
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        padding: 10px 25px;
        border: 2px solid #ffffff;
        box-sizing: border-box;
        border-radius: 45px;
        color: #fff;
        transition: opacity .2s ease;
        &:hover{
            color: #fff;
            opacity: .8;
        }
    }

    &__navigation {
        display: flex;
        justify-content: center;
        margin-top: 40px;

        .swiper-button-prev,
        .swiper-button-next {
            position: static;
            outline: none;
            background: #fff;
            border-radius: 20px;
            padding: 15px 20px;
            width: auto;
            height: auto;
            margin: 0 5px;
        }

        .swiper-button-prev {
            &::after {
                content: '';
                background: url('/assets/images/arrow-r.svg') no-repeat center;
                background-size: cover;
                width: 15px;
                height: 10px;
                transform: rotate(-180deg);
            }
        }

        .swiper-button-next {
            &::after {
                content: '';
                background: url('/assets/images/arrow-r.svg') no-repeat center;
                background-size: cover;
                width: 15px;
                height: 10px;
            }
        }
    }
}

@media (max-width: 992px){
    .us-write__title{
        margin-bottom: 30px;
        text-align: center;
    }
}

@media (max-width: 768px) {
    .us-write {
        background: #eaf1fc url(/assets/images/media.png) no-repeat left 23px;
        background-size: 500px;
        padding-top: 55px;
    }
}

@media (max-width: 576px) {
    .us-write {
        padding: 45px 0;
        padding-top: 50px;
        background: #eaf1fb url(/assets/images/media.png) no-repeat left 15%;
        background-size: 80%;
    }
}
</style>
